export function getErrorMessage (error) {
  if (error.response && typeof error.response.data === 'string') return `Error: ${error.response.data}`
  return error.message
}
